"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icons_1 = require("../Icons");
var BackButton_1 = __importDefault(require("./BackButton"));
var Breadcrumb_1 = __importDefault(require("./Breadcrumb"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var styled_components_1 = __importDefault(require("styled-components"));
var Breadcrumbs = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.crumbs, crumbs = _c === void 0 ? [] : _c, _d = _a.testid, testid = _d === void 0 ? 'breadcrumbs' : _d;
    return (React.createElement(StyledBreadcrumbs, { className: className, "data-testid": testid }, crumbs
        // dont try and make a breadcrumb without a label
        .filter(function (_a) {
        var label = _a.label;
        return Boolean(label);
    })
        .map(function (_a, index) {
        var back = _a.back, external = _a.external, label = _a.label, _b = _a.link, link = _b === void 0 ? '' : _b, onClick = _a.onClick;
        if (back) {
            return React.createElement(BackButton_1.default, { external: external, key: index, label: label, link: link, onClick: onClick });
        }
        return (React.createElement(React.Fragment, { key: index },
            index !== 0 && !crumbs[index - 1].back && React.createElement(StyledBreadcrumbArrowRightIcon, null),
            React.createElement(Breadcrumb_1.default, { external: external, label: label, link: link })));
    })));
};
exports.default = React.memo(Breadcrumbs, react_fast_compare_1.default);
var StyledBreadcrumbs = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    height: 18px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    height: 18px;\n"])));
var StyledBreadcrumbArrowRightIcon = (0, styled_components_1.default)(Icons_1.BreadcrumbArrowRightIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0 4px;\n    width: 14px;\n    height: 14px;\n    flex: 0 0 14px;\n"], ["\n    margin: 0 4px;\n    width: 14px;\n    height: 14px;\n    flex: 0 0 14px;\n"])));
var templateObject_1, templateObject_2;
